import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

import { getTimeZoneData } from '@modules/utils';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';
import { intl } from '@shared/localization';
import { toastService } from '@toasts';
import '@utils/rxjs.add.operator.catchAndReport';

import {
  DISABLE_FORUM_REQUEST,
  GET_TIMEZONES_REQUEST,
  SET_TIMEZONE_REQUEST,
  SYNC_FORUM_REQUEST,
  disableForumError,
  disableForumResponse,
  getTimezonesError,
  getTimezonesResponse,
  setTimezoneError,
  setTimezoneResponse,
  syncForumError,
  syncForumResponse,
} from './actions';
import services from './services';

const syncForumEpic$ = action$ =>
  action$.ofType(SYNC_FORUM_REQUEST).switchMap(({ payload }) =>
    services
      .enableForum$(payload)
      .do(() =>
        toastService.success(
          intl.formatMessage({ id: 'settings.ForumSwitch.syncSuccess' }),
        ),
      )
      .map(() => syncForumResponse())
      .catchAndReport(err => Observable.of(syncForumError(err))),
  );

const getTimezonesEpic$ = action$ =>
  action$.ofType(GET_TIMEZONES_REQUEST).switchMap(() =>
    services
      .getTimezones$()
      .mergeMap(payload => {
        const formattedResponse = payload.map(({ timezoneCode }) =>
          getTimeZoneData(timezoneCode),
        );
        return Observable.of(getTimezonesResponse(formattedResponse));
      })
      .catchAndReport(err => Observable.of(getTimezonesError(err))),
  );

const setTimezoneEpic$ = (action$, state$) =>
  action$.ofType(SET_TIMEZONE_REQUEST).switchMap(({ payload }) => {
    const { timezoneData } = payload;
    const organizationGuid = organizationGuidSel(state$.value);

    return services
      .setTimezone$(timezoneData, organizationGuid)
      .do(() =>
        toastService.success(
          intl.formatMessage({ id: 'settings.UnitTimezoneSettings.success' }),
        ),
      )
      .map(payload => setTimezoneResponse(payload))
      .catchAndReport(err => Observable.of(setTimezoneError(err)));
  });

const disableForumEpic$ = action$ =>
  action$.ofType(DISABLE_FORUM_REQUEST).switchMap(({ payload }) =>
    services
      .disableForum$(payload)
      .map(({ discourse }) => disableForumResponse(discourse))
      .catchAndReport(err => Observable.of(disableForumError(err))),
  );

export default combineEpics(
  syncForumEpic$,
  disableForumEpic$,
  getTimezonesEpic$,
  // getUnitDetailsEpic$,
  setTimezoneEpic$,
);
